import { proxy, subscribe } from "valtio"
import dayjs from "dayjs"

// function init() {
//   let flag = localStorage.getItem("collect")
//   if (!flag) {
//     localStorage.setItem(
//       "collect",
//       JSON.stringify({
//         collectSinameList: [],
//         collectSheetList: [],
//         collectVideoList: [],
//         collectSingerList: []
//       })
//     )
//   }
// }
// init()

const collectSetup = proxy(
  JSON.parse(localStorage.getItem("collect"))
    ? JSON.parse(localStorage.getItem("collect"))
    : {
        collectSinameList: [],
        collectSheetList: [],
        collectVideoList: [],
        collectSingerList: []
      }
)

/**
 * 添加收藏
 * @param {string} val1 添加的类型专辑、歌单、视频、歌手
 * @param {object} val2 添加的对象
 */
const addCollect = (val1, val2) => {
  switch (val1) {
    case "siname":
      collectSetup.collectSinameList.unshift({
        id: val2.id,
        picUrl: val2.picUrl,
        name: val2.name,
        colTime: dayjs().format("YYYY-MM-DD HH:mm:ss")
      })
      break
    case "sheet":
      collectSetup.collectSheetList.unshift({
        id: val2.id,
        coverImgUrl: val2.coverImgUrl,
        name: val2.name,
        colTime: dayjs().format("YYYY-MM-DD HH:mm:ss")
      })
      break
    case "video":
      collectSetup.collectVideoList.unshift({
        id: val2.id,
        cover: val2.cover,
        title: !val2.videoType ? val2.name : val2.title,
        type: val2.videoType,
        artists: !val2.videoType ? val2.artists : val2.creator.nickname,
        colTime: dayjs().format("YYYY-MM-DD HH:mm:ss")
      })
      break
    case "singer":
      collectSetup.collectSingerList.unshift({
        id: val2.artist.id,
        avatar: val2.artist.avatar,
        name: val2.artist.name,
        colTime: dayjs().format("YYYY-MM-DD HH:mm:ss")
      })
      break
  }
}
/**
 * 移除收藏
 * @param {string} val1 移除的类型专辑、歌单、视频、歌手
 * @param {number} val2 移除的对象的id
 */
const removeCollect = (val1, val2) => {
  let index = 0
  switch (val1) {
    case "siname":
      index = collectSetup.collectSinameList.findIndex(
        (item) => item.id == val2
      )
      collectSetup.collectSinameList.splice(index, 1)
      break
    case "sheet":
      index = collectSetup.collectSheetList.findIndex((item) => item.id == val2)
      collectSetup.collectSheetList.splice(index, 1)
      break
    case "video":
      index = collectSetup.collectVideoList.findIndex((item) => item.id == val2)
      collectSetup.collectVideoList.splice(index, 1)
      break
    case "singer":
      index = collectSetup.collectSingerList.findIndex(
        (item) => item.id == val2
      )
      collectSetup.collectSingerList.splice(index, 1)
      break
  }
}

subscribe(collectSetup, (state) => {
  localStorage.setItem("collect", JSON.stringify(collectSetup))
})

export { addCollect, removeCollect }
export default collectSetup
